/**
 * @generated SignedSource<<1dc5afc31ccfa64a0394e88c4ba6433a>>
 * @relayHash a41f6884506e32620b3b4d22baa9034b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9fdfc94dccb87d1ebd43e49c204e07b97c74c270d2be44f488b3b9d7e19e6395

import type { ConcreteRequest } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type ProjectPolicyConflictsPageContentQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type ProjectPolicyConflictsPageContentQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly isProjectAdmin: {
        readonly canPerform: boolean;
      } | null;
      readonly projectType: JiraProjectType | null;
    } | null;
  } | null;
};
export type ProjectPolicyConflictsPageContentQuery = {
  response: ProjectPolicyConflictsPageContentQuery$data;
  variables: ProjectPolicyConflictsPageContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v3 = {
  "alias": "isProjectAdmin",
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "EDIT_PROJECT_CONFIG"
    }
  ],
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPolicyConflictsPageContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPolicyConflictsPageContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9fdfc94dccb87d1ebd43e49c204e07b97c74c270d2be44f488b3b9d7e19e6395",
    "metadata": {},
    "name": "ProjectPolicyConflictsPageContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c7d5e1485a585e4e36530a8d7e0eca4d";

export default node;
